
import * as Website from './Config/Website.js';

import * as Common from './Page/Common/App.js';
import * as Home from './Page/Home/App.js';
import * as Intro from './Page/Intro/App.js';
import * as Technology from './Page/Technology/App.js';
import * as Overview from './Page/Overview/App.js';
import * as myCareer from './Page/myCareer/App.js';
import * as Interview from './Page/Interview/App.js';

const page = Website.status.page.toLowerCase();


Website.event.init();


// COMMON INIT
window.addEventListener("DOMContentLoaded", () => Common.preinit());
Common.init();
window.addEventListener("load", () => Common.load());
window.addEventListener("resize", () => Common.resize());
window.addEventListener('widthchange', () => Common.resizeW());
window.addEventListener("scroll", () => Common.scroll());
window.addEventListener("orientationchange", () => Common.resize());
window.addEventListener("orientationchange", () => Common.scroll());


switch(page) {
  case "home":
    Home.init();
    window.addEventListener('load', () => Home.load());
    window.addEventListener('resize', () => Home.resize());
    window.addEventListener('widthchange', () => Home.resizeW());
    window.addEventListener('scroll', () => Home.scroll());
    window.addEventListener("orientationchange", () => Home.resize());
    window.addEventListener("orientationchange", () => Home.scroll());
    break;
  case "intro":
    Intro.init();
    window.addEventListener('load', () => Intro.load());
    window.addEventListener('resize', () => Intro.resize());
    window.addEventListener('widthchange', () => Intro.resizeW());
    window.addEventListener('scroll', () => Intro.scroll());
    window.addEventListener("orientationchange", () => Intro.resize());
    window.addEventListener("orientationchange", () => Intro.scroll());
    break;
  case "technology":
    Technology.init();
    window.addEventListener('load', () => Technology.load());
    window.addEventListener('resize', () => Technology.resize());
    window.addEventListener('widthchange', () => Technology.resizeW());
    window.addEventListener('scroll', () => Technology.scroll());
    window.addEventListener("orientationchange", () => Technology.resize());
    window.addEventListener("orientationchange", () => Technology.scroll());
    break;
  case "overview":
    Overview.init();
    window.addEventListener('load', () => Overview.load());
    window.addEventListener('resize', () => Overview.resize());
    window.addEventListener('widthchange', () => Overview.resizeW());
    window.addEventListener('scroll', () => Overview.scroll());
    window.addEventListener("orientationchange", () => Overview.resize());
    window.addEventListener("orientationchange", () => Overview.scroll());
    break;
  case "mycareer":
    myCareer.init();
    window.addEventListener('load', () => myCareer.load());
    window.addEventListener('resize', () => myCareer.resize());
    window.addEventListener('widthchange', () => myCareer.resizeW());
    window.addEventListener('scroll', () => myCareer.scroll());
    window.addEventListener("orientationchange", () => myCareer.resize());
    window.addEventListener("orientationchange", () => myCareer.scroll());
    break;
  case "interview":
    Interview.init();
    window.addEventListener('load', () => Interview.load());
    window.addEventListener('resize', () => Interview.resize());
    window.addEventListener('widthchange', () => Interview.resizeW());
    window.addEventListener('scroll', () => Interview.scroll());
    window.addEventListener("orientationchange", () => Interview.resize());
    window.addEventListener("orientationchange", () => Interview.scroll());
    break;
}